import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { AppSettings } from '../../../settings/index';
import { AuthHttp } from '../../../common/index';

@Injectable()
export class ReportFormatService {
    constructor(private http: AuthHttp) { }

    getReportFormats() {
        return this.http.get(AppSettings.apiEndpoint + 'ReportFormat/GetReportFormats')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/config/report-format.service.ts